import type { FaireProductEntity } from "../../entity_types/product";

export const p_8tzrz5h2xg: FaireProductEntity = {
  token: "p_8tzrz5h2xg",
  type: "product",
  name: "Palo santo stick with cone Aroma Scent Scented Candles",
  brandToken: "b_9jg4fbzgpg",
  brandName: "Like International",
  imageUrl:
    "https://cdn.faire.com/fastly/ef5e4deab730f3d31ca231bfe64d1baca98e436aac53dfe1c86a9f47abc33197.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/13ed8abdaa91ebc25fd13f11a56e7cd9fd27e9111f104e85a31e6b9f4704cf0a.jpeg",
    "https://cdn.faire.com/fastly/0c5719b8e2c54fb04c2d72baf305333455040fac1480796d6f9c06450dd4eae6.jpeg",
  ],
  priceDollars: 5.54,
  description:
    "Our Palo Santo with cone Smudge is the perfect fit for you, whether you're a Palo Santo pro or a beginner. Our Palo Santo will leave your home surrounded with good vibes and a fresh smile air\nSome of our bundles are homegrown and harvested, which makes them super fresh and fragrant. Our large sage plants produce a good amount of sage, which we love to use to provide our customers with the best sage we can find.\n\nPalo Santo is used to leaving your home smelling fragrant and fresh and is also believed by many to have healing and spiritual benefits. It is said that burning palo santo in your home will bring prosperity and wisdom to your home and anyone in your household.\n\nOur Palo Santo sticks with cone\nThey are each approximately 4\"stick\nHarvested strong lasting aroma scent incense scented candles spiritual",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:25.633Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
